module.exports = __webpack_public_path__ + "img/right-arrow.ee7a7396.svg";